import styled from "styled-components"

const WarnTextStyled = styled.p<{ $isHidden: boolean }>`
  color: ${({ theme }) => theme.colors.warn};
  font-size: 14px;
  font-weight: 600;
  visibility: ${({ $isHidden }) => $isHidden ? 'hidden' : 'visible'};
  margin-top: 0;
  margin-left: 1rem;
`
type WarnTextProps = {
  text: string
  hidden?: boolean
}

export const WarnText = ({ text, hidden = false }: WarnTextProps) => {
  return (
    <WarnTextStyled $isHidden={hidden}>{text}</WarnTextStyled>
  )
}